import React, { useState, useEffect } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

const VerbTypes = (props) => {

  const [verb_type, setverb_type] = useState("All");
  const [verb_types, setverb_types] = useState([
    { name: "All" },
    { name: "AR" },
    { name: "ER" },
    { name: "IR" },
    { name: "Irregular" },
  ]);

  const handleCollectionChange = (event) => {
    setverb_type(event.target.value);
    props.handleSettingChange("verb_type",event.target.value);
  };

  useEffect(() => {
    setverb_type(props.verb_type);
      return () => {
          
      }
  }, [])

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="name-language">Verb ending</InputLabel>
      <Select
        fullWidth
        value={verb_type}
        onChange={handleCollectionChange}
        inputProps={{
          name: "language",
          id: "name-language",
        }}
      >
        {typeof verb_types != "undefined" &&
        verb_types.map((se) => <MenuItem value={se.name}>{se.name}</MenuItem>)}
      </Select>
    </FormControl>
  );
};

export default VerbTypes;